import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibGoogle,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibCcStripe,
  cibCcPaypal,
  cibCcApplePay,
  cibCcAmex,
  cilContact,
  cilHome,
  cilCursorMove,
} from '@coreui/icons'
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from '@coreui/icons'
import {
  cilAlignCenter,
  cilAccountLogout,
  cilAlignLeft,
  cilAlignRight,
  cilPlaylistAdd,
  cilMinus,
  cilApplicationsSettings,
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBan,
  cilBasket,
  cilBell,
  cilBookmark,
  cilBold,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilCheckAlt,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilFile,
  cilGlobeAlt,
  cilGrid,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilItalic,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilLocationPin,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMediaPlay,
  cilMenu,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPrint,
  cilPuzzle,
  cilSave,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilDataTransferDown,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilColorBorder,
  cilSearch,
  cilUserFollow,
  cilGraph,
  cilXCircle,
  cilX,
  cilDataTransferUp,
  cilPlus,
  cilEducation,
  cilCommentBubble,
  cilBuilding,
  cilMoney,
  cilInfo,
  cilClipboard,
  cilCart,
  cilLevelUp,
  cilDescription,
  cilCaretBottom,
  cilCaretTop,
  cilExternalLink,
  cilSend,
  cilAlarm,
  cilArrowThickFromLeft,
  cilFolder,
  cilLibraryBuilding,
  cilCopy,
  cilAddressBook,
  cilListRich,
  cilScreenDesktop,
  cilBook,
  cilWarning,
  cilApps,
  cilHappy,
  cilClock,
  // cilArrowThickFromRight,
  cilArrowLeft,
  // cilArrowCircleLeft,
  cilFlagAlt,
  cilChatBubble,
} from '@coreui/icons'

import { estrella, estrellaRellenada } from './iconos-importados';

export const iconsSet = Object.assign(
  {},
  { estrella },
  { estrellaRellenada },
  {
    cilCart,
    cilAlarm,
    cilExternalLink,
    cilCursorMove,
    cilWarning,
    cilClipboard,
    cilLevelUp,
    cilCaretBottom,
    cilCaretTop,
    cilEducation,
    cilMoney,
    cilAlignCenter,
    cilGraph,
    cilSearch,
    cilDescription,
    cilBuilding,
    cilCommentBubble,
    cilPlus,
    cilInfo,
    cilAlignLeft,
    cilAlignRight,
    cilContact,
    cilPlaylistAdd,
    cilColorBorder,
    cilDataTransferDown,
    cilDataTransferUp,
    cilHome,
    cilApplicationsSettings,
    cilArrowBottom,
    cilArrowRight,
    cilMinus,
    cilArrowTop,
    cilBan,
    cilAccountLogout,
    cilBasket,
    cilBell,
    cilBookmark,
    cilBold,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilCheckAlt,
    cilChevronBottom,
    cilChevronLeft,
    cilChevronRight,
    cilChevronTop,
    cilCheckCircle,
    cilCode,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeLetter,
    cilEnvelopeOpen,
    cilEuro,
    cilFile,
    cilGlobeAlt,
    cilGrid,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilItalic,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilListNumbered,
    cilLocationPin,
    cilLockLocked,
    cilLockUnlocked,
    cilMagnifyingGlass,
    cilMediaPlay,
    cilMenu,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperPlane,
    cilPaperclip,
    cilPencil,
    cilPeople,
    cilPrint,
    cilPuzzle,
    cilSave,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilSun,
    cilTags,
    cilTask,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilX,
    cilSend,
    cilArrowThickFromLeft,
    cilFolder,
    cilLibraryBuilding,
    cilCopy,
    cilAddressBook,
    cilListRich,
    cilScreenDesktop,
    cilBook,
    cilApps,
    cilHappy,
    cilClock,
    // cilArrowThickFromRight,
    cilArrowLeft,
    // cilArrowCircleLeft,
    cilFlagAlt,
    cilChatBubble,
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibGoogle,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibCcStripe,
    cibCcPaypal,
    cibCcApplePay,
    cibCcAmex,
  },
)
